var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"type":"transition"},on:{"before-enter":_vm.initializePosition,"enter":_vm.animateWalk,"after-enter":_vm.completeWalk}},[_c('div',{staticClass:"cover cat-animation",class:[_vm.name, _vm.animationClass]})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435aa922","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cat/Walk.vue
// module id = null
// module chunks = 